<div *ngIf="isLoading" class="wrapper">
  <div class="text">{{ 'updating.updating' | translate }}...</div>
  <img height="20px" [src]="src" />
</div>
